<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item" class="mb-2">
        <b-col>
          <router-link v-if="ableToEditFirm" :to="{ name: 'FirmUpdate', params: { id: item['@id'] } }" class="btn btn-default btn-sm">
            <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
            <i v-else class="far fa-edit"></i>
          </router-link>
          <button v-if="ableToEditFirm && item.state === 1" class="btn btn-warning btn-sm" @click="archiveItem(item['@id'])">{{ $t('buttons.archive') }}</button>
          <button v-if="ableToEditFirm && item.state === 0" class="btn btn-warning btn-sm" @click="unArchiveItem(item['@id'])">{{ $t('buttons.unArchive') }}</button>
          <router-link
            v-if="prevRoute && prevRoute.name === 'TimetableDashboard'"
            :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'FirmList', query: {p: currentPage} }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col :cols="8">
          <b-card>
            <b-tabs v-model="tabIndex2" content-class="mt-3">
              <b-tab :title="$t('views.firm.show.title')">
                <FirmData :idFirm="item"></FirmData>
              </b-tab>
              <b-tab :title="$t('views.firm.show.userDataEmployees')">
                <EmployeeList :ableToEditFirm="ableToEditFirm" @refetchData="retrieve(idFirm)" :idFirm="item"></EmployeeList>
              </b-tab>
              <b-tab v-if="ableToViewOrganizationLeads" :title="$t('menu.exaborganizationleads.list')">
                <OrganizationLeadList
                  :idUserData="item['@id']"
                  :addNoteToOrganizationLeadModal="addNoteToOrganizationLead"
                  :addPhoneToOrganizationLeadModal="addPhoneToOrganizationLead"
                  :addMeetingToOrganizationLeadModal="addMeetingToOrganizationLead"
                />
              </b-tab>
              <b-tab v-if="ableToViewApplications" :title="$t('menu.application.index')">
                <Applications :firm="item"></Applications>
              </b-tab>
              <b-tab :title="$t('views.firm.form.firmDepartments')">
                <departments :idFirm="item['@id']"></departments>
              </b-tab>
              <b-tab :title="$t('views.firm.show.addresses')">
                <UserDataAddresses :ableToEditFirm="ableToEditFirm" :id-user-data="item['@id']"></UserDataAddresses>
              </b-tab>
              <b-tab :title="$t('menu.agreementdevices.list')" v-if="ableToViewDevices">
                <devices-list :id-firm="item['@id']"></devices-list>
              </b-tab>
              <b-tab v-if="$store.getters['configuration/mailerLiteStatus']" :title="$t('views.userdata.show.mailerLiteStatusInfo')">
                <user-data-mailer-lite-box :data="item"></user-data-mailer-lite-box>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card>
            <b-col class="mt-2">
              <upcoming-relations
                :id-firm="parseInt(getIdLink(idFirm))"
                :contact-type="1"
              ></upcoming-relations>
            </b-col>
          </b-card>
          <b-card>
            <b-col class="mt-2">
              <upcoming-relations
                :id-firm="parseInt(getIdLink(idFirm))"
                :contact-type="2"
              ></upcoming-relations>
            </b-col>
          </b-card>
          <b-card>
            <b-col class="mt-2">
              <timetable-notes :id-firm="idFirm" :hide-add-modal="idOrganizationLeadToCreateRelation !== null"></timetable-notes>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
      <b-card>
        <b-row v-if="item">
          <b-col>
            <b-tabs v-model="tabIndex" content-class="mt-3">
              <b-tab :title="$t('views.excmcase.list.titleOpened')" @click="changeCasesTab(1)">
                <CasesList :search-params="{relatedUserData: getIdLink(idFirm), status: 1, disableRolesFiltering: 1}" v-if="openCasesTab"></CasesList>
              </b-tab>
              <b-tab :title="$t('views.excmcase.list.titleClosed')" @click="changeCasesTab(2)">
                <CasesList :search-params="{relatedUserData: getIdLink(idFirm), status: 2, disableRolesFiltering: 1}" v-if="closedCasesTab"></CasesList>
              </b-tab>
              <b-tab :title="$t('views.exsbinvoices.list.title')" v-if="ableToViewInovices">
                <InvoiceListWithoutBcard :firmIRI="idFirm"></InvoiceListWithoutBcard>
              </b-tab>
              <b-tab no-body :title="$t('views.excmmessages.list.messagesApproved')" v-if="ableToViewMessages">
                <MessagesApprovedList :messageRecipientUserDataContractorFilter="idFirm"/>
              </b-tab>
              <b-tab no-body :title="$t('views.excmmessages.list.messagesToApprove')" v-if="ableToViewMessages">
                <MessagesToApproveList :messageRecipientUserDataContractorFilter="idFirm"/>
              </b-tab>
              <b-tab :title="$t('menu.excmcorrespondence.list')" v-if="ableToViewCorrespondenceThreads">
                <CorrespondenceThreadsTable :idContractor="idFirm"></CorrespondenceThreadsTable>
              </b-tab>
              <b-tab :title="$t('menu.excmcalllogs.list')" v-if="ableToViewCallLog">
                <CallLogTable :callLogRelatedContractorFilter="idFirm"></CallLogTable>
              </b-tab>
              <b-tab :title="$t('menu.excmcalllogs.statistic')" v-if="ableToViewCallLog">
                <CallLogLastMonthTable :firmIRI="idFirm"></CallLogLastMonthTable>
              </b-tab>
              <b-tab :title="$t('views.excmagreements.list.title')" v-if="ableToViewAgreements">
                <AgreementsTable :id-firm="idFirm"></AgreementsTable>
              </b-tab>
              <b-tab
                :title="$t('routes.EXSBPaymentsMadeList')"
                v-if="ableToViewPaymentsMade && item.paymentsMade && item.paymentsMade.length > 0">
                <table class="table table-sm table-grid">
                  <thead>
                  <tr>
                    <th>{{ $t('views.exsbpaymentsmade.list.paymentDate') }}</th>
                    <th>{{ $t('views.exsbpaymentsmade.list.agreement') }}</th>
                    <th>{{ $t('views.exsbpaymentsmade.list.invoice') }}</th>
                    <th>{{ $t('views.exsbpaymentsmade.list.bank') }}</th>
                    <th style="width: 5%"> </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in item.paymentsMade" :key="item['@id']">
                    <td>{{ $moment(item.paymentDate).format('YYYY-MM-DD') }}</td>
                    <td>
                      <router-link v-if="ableToViewAgreements" :to="{ name: 'EXCMAgreementShow', params: { id: item.idAgreement['@id'] } }">
                        {{ item.idAgreement.agreementNumber }}
                      </router-link>
                      <span v-else>{{ item.idAgreement.agreementNumber }}</span>
                    </td>
                    <td>
                      <router-link v-if="ableToViewInovices" :to="{ name: 'EXSBInvoiceShow', params: { id: item.idEXSBInvoice['@id'] } }">
                        {{ item.idEXSBInvoice.number }}
                      </router-link>
                      <span v-else>{{ item.idEXSBInvoice.number }}</span>
                    </td>
                    <td>
                      {{ item.idBank.title }}
                    </td>
                    <td>
                      <router-link
                        v-if="ableToViewPaymentsMade"
                        tag="button"
                        :to="{ name: 'EXSBPaymentsMadeShow', params: {id: item['@id']} }"
                        class="fa fa-search fa-lg btn btn-sm btn-link"
                      ></router-link>
                      <span v-else></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-tab>
              <b-tab :title="$t('menu.relations.meetings')">
                <RelationsTable :contact-type="1" :id-firm="parseInt(getIdLink(idFirm))"></RelationsTable>
              </b-tab>
              <b-tab :title="$t('menu.relations.phones')">
                <RelationsTable :contact-type="2" :id-firm="parseInt(getIdLink(idFirm))"></RelationsTable>
              </b-tab>
              <b-tab :title="$t('menu.exsbpriceuserdata.list')" v-if="ableToViewPriceUserData">
                <PriceUserDataList :user-data="idFirm" ></PriceUserDataList>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="item">
        <b-col>
          <document-files :path="'api/user_datas/'" :item="item" :fetch-data="() => retrieve(idFirm)"></document-files>
        </b-col>
      </b-card>
      <CreateUserDataEmployeeModal v-if="ableToEditFirm"></CreateUserDataEmployeeModal>
      <UpdateUserDataEmployeeModal v-if="ableToEditFirm"></UpdateUserDataEmployeeModal>
      <MeetingCreateModal v-if="idOrganizationLeadToCreateRelation" :id-organization-lead="idOrganizationLeadToCreateRelation"></MeetingCreateModal>
      <MeetingCreateModal v-else :id-firm="idFirm"></MeetingCreateModal>
      <PhoneCreateModal v-if="idOrganizationLeadToCreateRelation" :id-organization-lead="idOrganizationLeadToCreateRelation"></PhoneCreateModal>
      <PhoneCreateModal v-else :id-firm="idFirm"></PhoneCreateModal>
      <AddNoteModal v-if="idOrganizationLeadToCreateRelation" :id-organization-lead="idOrganizationLeadToCreateRelation"></AddNoteModal>
      <InvoicePositionEditModal></InvoicePositionEditModal>
      <InvoiceDataEditModal></InvoiceDataEditModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CreateUserDataEmployeeModal from '../userdataemployee/components/CreateUserDataEmployeeModal'
import UpdateUserDataEmployeeModal from '../userdataemployee/components/UpdateUserDataEmployeeModal'
import { archive, unArchive } from '@/utils/archive'
import { checkPagePermission, checkPermission, getUserRoles } from '@/utils/checkRoles.js'
import getId from '@/utils/getIdFromLink'
import Loader from '../../Layout/Loader'
import InvoiceListWithoutBcard from '../BusinessBundle/exsbinvoice/components/InvoiceListWithoutBcard'
import AgreementsTable from '../excmagreement/Table'
import CasesList from '../excmcase/Table'
import TimetableNotes from '@/components/Dashboard/Views/common/TimetableNotes'
import addParamsToQuery from '../../../../utils/addParamsToQuery'
import UpcomingRelations from '@/components/Dashboard/Views/common/UpcomingRelations'
import FirmData from './components/FirmData'
import EmployeeList from './components/EmployeeList'
import InvoiceDataEditModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/InvoiceDataEditModal/InvoiceDataEditModal'
import InvoicePositionEditModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/InvoicePositionEditModal/InvoicePositionEditModal'
import Applications from '@/components/Dashboard/Views/firm/components/Applications'
import MeetingCreateModal from '@/components/Dashboard/Views/excmrelation/modals/MeetingCreateModal'
import PhoneCreateModal from '@/components/Dashboard/Views/excmrelation/modals/PhoneCreateModal'
import PriceUserDataList from '@/components/Dashboard/Views/BusinessBundle/exsbpriceuserdata/List'
import Departments from '@/components/Dashboard/Views/firm/components/Departments'
import UserDataAddresses from '@/components/Dashboard/Views/userdataaddress/List'
import DevicesList from '@/components/Dashboard/Views/excmagreementdevice/List'
import UserDataMailerLiteBox from '@/components/Dashboard/Views/userdata/component/MailerLite/userDataMailerLiteBox'
import RelationsTable from '@/components/Dashboard/Views/excmrelation/RelationsTable'
import CallLogLastMonthTable from '@/components/Dashboard/Views/excmcalllog/components/CallLogLastMonthTable'
import CallLogTable from '@/components/Dashboard/Views/excmcalllog/CallLogTable'
import CorrespondenceThreadsTable from '@/components/Dashboard/Views/excmcorrespondence/CorrespondenceThreadsTable'
import DocumentFiles from '@/components/Dashboard/Views/common/DocumentFiles'
import MessagesToApproveList from '@/components/Dashboard/Views/excmmessage/MessagesToApproveList.vue'
import MessagesApprovedList from '@/components/Dashboard/Views/excmmessage/MessagesApprovedList.vue'
import OrganizationLeadList from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/OrganizationLeadList.vue'
import AddNoteModal from '@/components/Dashboard/Views/excmnote/modals/CreateNoteModal.vue'

export default {
  components: {
    AddNoteModal,
    OrganizationLeadList,
    MessagesApprovedList,
    MessagesToApproveList,
    DocumentFiles,
    CorrespondenceThreadsTable,
    CallLogTable,
    CallLogLastMonthTable,
    RelationsTable,
    UserDataMailerLiteBox,
    UserDataAddresses,
    AgreementsTable,
    PhoneCreateModal,
    Applications,
    InvoiceDataEditModal,
    InvoicePositionEditModal,
    CreateUserDataEmployeeModal,
    UpdateUserDataEmployeeModal,
    Loader,
    InvoiceListWithoutBcard,
    CasesList,
    // NotesList,
    TimetableNotes,
    UpcomingRelations,
    MeetingCreateModal,
    FirmData,
    EmployeeList,
    PriceUserDataList,
    Departments,
    DevicesList
  },

  computed: {
    idFirm () {
      return this.$store.state.picker.current
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      deleteError: 'userdata/del/error',
      error: 'userdata/show/error',
      isLoading: 'userdata/show/isLoading',
      item: 'userdata/show/retrieved',
      currentPage: 'userdata/list/currentPage',
      employeeCreated: 'userdataemployee/create/created',
      isCreateNoteModalVisible: 'excmnote/createModal/getIsVisible',
      isCreateMeetingModalVisible: 'excmrelation/createModal/getIsMeetingModalVisible',
      isCreatePhoneModalVisible: 'excmrelation/createModal/getIsPhoneModalVisible'
    }),
    ableToViewPriceUserData () {
      return checkPermission('warehouses', 'EXSBPriceUserDataList')
    },
    ableToEditFirm () {
      if (this.checkRoles('firms', 'FirmUpdate')) {
        return true
      }
      return this.item && this.item.createdBy === parseInt(getUserRoles().id)
    },
    ableToUserDataShow () {
      return this.checkRoles('userdatas', 'UserDataShow')
    },
    ableToUserShow () {
      return this.checkRoles('userdatas', 'UserShow')
    },
    ableToViewAgreements () {
      return this.checkRoles('agreements', 'EXCMAgreementList')
    },
    ableToViewInovices () {
      return this.checkRoles('finances', 'EXSBInvoiceList')
    },
    ableToViewApplications () {
      return this.checkRoles('application', 'ApplicationList') && this.item.applications
    },
    ableToViewPaymentsMade () {
      return this.checkRoles('finances', 'EXSBPaymentsMadeList')
    },
    ableToViewDevices () {
      return this.checkRoles('devices', 'EXCMDeviceList')
    },
    ableToViewCallLog () {
      return this.checkRoles('firms', 'EXCMCallLogList')
    },
    ableToViewCorrespondenceThreads () {
      return this.checkRoles('firms', 'EXCMCorrespondenceThreadsList')
    },
    ableToViewMessages () {
      return this.checkRoles('configuration', 'EXCMMessageList')
    },
    ableToViewOrganizationLeads () {
      return this.checkRoles('firms', 'EXABOrganizationLeadList')
    }
  },

  watch: {
    isCreatePhoneModalVisible (val) {
      if (!val) {
        this.idOrganizationLeadToCreateRelation = null
      }
    },
    isCreateMeetingModalVisible (val) {
      if (!val) {
        this.idOrganizationLeadToCreateRelation = null
      }
    },
    isCreateNoteModalVisible (val) {
      if (!val) {
        this.idOrganizationLeadToCreateRelation = null
      }
    },
    'idFirm' () {
      this.retrieve(this.idFirm)
      this.getNotes()
      this.changeCasesTab(1)
      if (!(decodeURIComponent(this.$router.history.current.path).includes(this.idFirm))) {
        this.$router.push({ name: 'FirmShow', params: { id: this.idFirm } })
      }
    },
    employeeCreated (val) {
      if (val) this.retrieve(this.idFirm)
    }
  },

  beforeCreate () {
    checkPagePermission('firms', 'FirmShow')
  },

  beforeDestroy () {
    this.reset()
    this.$store.state.picker.current = ''
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  data () {
    return {
      colSize: 0,
      switcher: false,
      closedCasesTab: false,
      openCasesTab: false,
      tabIndex: 0,
      tabIndex2: 0,
      prevRoute: null,
      relationsPeriod: 'month',
      idOrganizationLeadToCreateRelation: null
    }
  },

  created () {
    this.setCurrentFirm()
    // this.retrieve(decodeURIComponent(this.idFirm))
    this.getNotes()
    this.changeCasesTab(1)
  },

  methods: {
    setCurrentFirm () {
      this.$store.state.picker.current = this.$route.params.id
    },
    getNotes () {
      let searchParams = {
        idUserData: this.$store.state.picker.current,
        state: 1
      }
      let url = addParamsToQuery('e_x_c_m_notes', searchParams)
      this.getNotesList(url)
    },
    ...mapActions({
      reset: 'userdata/show/reset',
      retrieve: 'userdata/show/retrieve',
      getNotesList: 'excmnote/list/default'
    }),
    ...mapMutations({
      toggleAddNoteModal: 'excmnote/createModal/toggleModal',
      toggleMeetingModal: 'excmrelation/createModal/toggleMeetingModal',
      togglePhoneModal: 'excmrelation/createModal/togglePhoneModal'
    }),
    changeCasesTab (val) {
      if (val === 1) {
        this.openCasesTab = true
        this.closedCasesTab = false
      } else {
        this.openCasesTab = false
        this.closedCasesTab = true
      }
    },
    archiveItem (id) {
      archive(id, () => { this.retrieve(this.idFirm) })
    },
    unArchiveItem (id) {
      unArchive(id, () => { this.retrieve(this.idFirm) })
    },
    addNoteToOrganizationLead (idOrganizationLead) {
      this.idOrganizationLeadToCreateRelation = idOrganizationLead
      this.toggleAddNoteModal()
    },
    addPhoneToOrganizationLead (idOrganizationLead) {
      this.idOrganizationLeadToCreateRelation = idOrganizationLead
      this.togglePhoneModal()
    },
    addMeetingToOrganizationLead (idOrganizationLead) {
      this.idOrganizationLeadToCreateRelation = idOrganizationLead
      this.toggleMeetingModal()
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
